<template>
<div>
    <v-row no-gutters class="im-result im-result-translations" align="center">
        <div class="px-2" style="width: 30%">
            <div class="text-capitalize regular py-1">{{ item.platform.name }}</div>
            <im-search-identifier ref="searchIdent" @input="emitInput" :item.sync="item.identifier" :app_slug="item.platform.slug"></im-search-identifier>
        </div>
        <div class="" style="width: 70%">
            <v-row no-gutters class="translations-card" v-for="(lang, index) in selected_languages" :key="index">
                <div>
                    <span>{{ lang }}:</span>
                </div>
                <v-col cols="11" class="px-3">
                    <im-language-identifier ref="langIdent" @input="emitInput" :identifier.sync="item.translations[lang.toLowerCase()]" />
                </v-col>
            </v-row>
        </div>
    </v-row>
</div>
</template>

<script>
import defaults from "../utils/PropDefaults.js";
import LanguageIdentifier from "../utils/LanguageIdentifier.vue";
import SearchIdentifier from "../utils/SearchIdentifier.vue";

export default {
    components: {
        'im-language-identifier': LanguageIdentifier,
        'im-search-identifier': SearchIdentifier
    },
    props: {
        item: {
            type: Object,
            default: defaults.one_static_pages
        },
        selected_languages: {
            type: Array,
            default: ['RO', 'EN']
        },
        edit_languages: {
            type: Array,
            default: []
        },
        readonly: {
            type: Boolean,
            default: false
        },
        is_saved: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        is_saved() {
            if(this.is_saved == true) {
                // console.log(this.$refs.langIdent);
                this.$refs.langIdent.forEach(function (item) {
                    item.clean();
                });
                this.$refs.searchIdent.clean();
            }
        }
    },

    methods: {
        getIdentifier(lang) {
            let key = lang.toLowerCase();
            return this.item.translations[key];
        },
        edit(lang) {
            return !this.edit_languages.includes(lang);
        },

        emitInput(event) {
            this.$emit('input', event);
        },
    },

}
</script>
<style>
.block-ellipsis {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 40px;
    margin: 0 auto;
    line-height: 1;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.im-result-translations {
    padding: 0 !important;
}

.translations-card {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.translations-card span {
    text-transform: capitalize;
}
</style>
